/**
 * Instancie une mention légale de l'application
 */
export class MentionLegale {
    /**
     * Constructeur de l'objet MentionLegale
     * @param row array contenant les données de l'objet
     */
    constructor(row) {
        if (row) {
            const { idMentionLegale, titre, contenu, ordre } = row;
            this.idMentionLegale = idMentionLegale !== null && idMentionLegale !== void 0 ? idMentionLegale : null;
            this.titre = titre !== null && titre !== void 0 ? titre : null;
            this.contenu = contenu !== null && contenu !== void 0 ? contenu : null;
            this.ordre = ordre !== null && ordre !== void 0 ? ordre : null;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVudGlvbkxlZ2FsZS5jbGFzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIk1lbnRpb25MZWdhbGUuY2xhc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sYUFBYTtJQXFCekI7OztPQUdHO0lBQ0gsWUFBbUIsR0FBNEI7UUFDOUMsSUFBSSxHQUFHLEVBQUU7WUFDUixNQUFNLEVBQUUsZUFBZSxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLEdBQUcsR0FBRyxDQUFDO1lBQ3ZELElBQUksQ0FBQyxlQUFlLEdBQUcsZUFBZSxhQUFmLGVBQWUsY0FBZixlQUFlLEdBQUksSUFBSSxDQUFDO1lBQy9DLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxhQUFMLEtBQUssY0FBTCxLQUFLLEdBQUksSUFBSSxDQUFDO1lBQzNCLElBQUksQ0FBQyxPQUFPLEdBQUcsT0FBTyxhQUFQLE9BQU8sY0FBUCxPQUFPLEdBQUksSUFBSSxDQUFDO1lBQy9CLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxhQUFMLEtBQUssY0FBTCxLQUFLLEdBQUksSUFBSSxDQUFDO1NBQzNCO0lBQ0YsQ0FBQztDQUNEIn0=